// @flow

import { handleMapRequest } from '../phasedActionHelpers';

import type { LoadDiscoverGroupAction } from '../../actions/discover';
import type { DiscoverGroup } from '../../shapes/types';

export type State = {
  +[key: string]: {|
    +entities: DiscoverGroup,
    +loaded: boolean,
    +loading: boolean,
  |},
};

const initialState = {};

export default function discoverGroups(
  state: State = initialState,
  action: LoadDiscoverGroupAction
): State {
  if (action.type === 'FETCH_DISCOVER_GROUP' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
